/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Signup_Dpa_RequiredInputs */

const cs_auth_signup_dpa_required = /** @type {(inputs: Auth_Signup_Dpa_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro založení účtu musíte odsouhlasit DPA.`)
};

const en_auth_signup_dpa_required = /** @type {(inputs: Auth_Signup_Dpa_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You must accept the DPA to create an account.`)
};

/**
* | output |
* | --- |
* | "You must accept the DPA to create an account." |
*
* @param {Auth_Signup_Dpa_RequiredInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_signup_dpa_required = /** @type {((inputs?: Auth_Signup_Dpa_RequiredInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Signup_Dpa_RequiredInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_signup_dpa_required(inputs)
	return cs_auth_signup_dpa_required(inputs)
});